module.exports = __webpack_public_path__ + "img/product-2.77b37097.png";